export class ConfigModel 
{
    dtype:string
    Maxslav:string
    Slvid:string
    brate:string 
    prty:string
    intm:string
    apn:string
    URL:string
    port:string
    kid:string
    FTPUsername:string
    FTPPassword:string
    CSVFileName:string
   }

export class ConfigRTCModel
{
    TimeZone:number
    DateTime:string
}

export class MqttSettingsModel
{
    protocol:string
    ClientName:string
    port:string
    MqttUsername:string
    MqttPassword:string
    MqttPublishtopic:string
    MqttPublishdatakey:string
}

export class CsvHeaderModel
{
    DeviceNo:number
    Header1:string
    Header2:string
    Header3:string
    Header4:string
    Header5:string
}
